import { useQuery } from '@tanstack/react-query';
import { update } from 'lodash';

import { fetchSearchAllContracts } from '@octopus/api';
import {
  contractStatuses,
  contractTypes,
  workerCategory,
} from '@octopus/contract-types';
import {
  DataGridProps,
  prepareDataGridSearchInput,
} from '@octopus/ui/data-grid';

export function useSearchEmployees({
  organizationId,
  activeTab,
  dataGridProps,
}: {
  organizationId: string;
  activeTab: string;
  dataGridProps: DataGridProps;
}) {
  const searchInput = update(
    prepareDataGridSearchInput(dataGridProps),
    'filtering.elements',
    (elements) => {
      return {
        ...elements,
        status: [contractStatuses.active],
        contractType: [contractTypes.brClt],
        workerCategory: [workerCategory.cltGeral],
      };
    },
  );

  const queryKey = ['contracts', organizationId, searchInput, activeTab];

  return useQuery({
    queryKey,
    queryFn: () =>
      fetchSearchAllContracts({
        pathParams: {
          organizationId,
        },
        body: searchInput,
      }),
    enabled: !!organizationId && activeTab === 'collaborators',
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
